import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { ConfigurationService } from "@/shared-module/services/configuration.service";

@Injectable({ providedIn: "root" })
export class DecisionPageService {
  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService,
  ) {}

  getdecision(
    id: string,
    path: string = null,
    subpath: string = null,
    prms: any = null,
  ) {
    this.configurationService.refreshConfig();
    if (subpath !== null) {
      return this.http
        .get<string>(`api/decisionpage/${id}/${path}/${subpath}`, {
          params: prms,
        })
        .pipe((s) => {
          return s;
        });
    }
    if (path !== null) {
      return this.http
        .get<string>(`api/decisionpage/${id}/${path}`, { params: prms })
        .pipe((s) => {
          return s;
        });
    }
    return this.http
      .get<string>(`api/decisionpage/${id}`, { params: prms })
      .pipe((s) => {
        return s;
      });
  }
}
